module.exports = __webpack_public_path__ + "static/media/tracing.ea58e0a1.png";